class SinglePole {

  constructor() {

    this.debug = window.location.search == "?debug" ? true : false;
    // this.debug = true;
  }

  init() {

    let _self = this;

    if(_self.debug) console.log('SinglePole init', $('.o-poles-thumbs .swiper-slide'));
    let polesThumbs = $('.o-poles-thumbs');
    if(polesThumbs.length && polesThumbs.find('.swiper-slide').length > 1) {
      // let polesThumbsSlides = polesThumbs.find('.swiper-slide');
      polesThumbs.each(function(i,polesThumbsEl){
        let polesThumbsActiveSlide = $(polesThumbsEl).find('.swiper-slide.is-active');
        if(_self.debug) console.log('SinglePole polesThumbsActiveSlide', polesThumbsActiveSlide, polesThumbsActiveSlide.index());
        if(_self.debug) console.log('polesThumbsEl?', polesThumbsEl);
        let polesThumbsSwiper = new Swiper(polesThumbsEl, {
          slidesPerView: 'auto',
          // autoHeight: true,
          // slidesPerColumn: 2,
          spaceBetween: 24,
          // slidesPerGroup: 2,
          // centeredSlides: true,
          // spaceBetween: -5,
          initialSlide: polesThumbsActiveSlide.index(),
          watchOverflow: true,
          // loop: true,
          // loopedSlides: polesThumbsSlides.length,
          // loopFillGroupWithBlank: true,
          navigation: {
            nextEl: $(polesThumbsEl).find('.swiper-button-next').get(0),
            prevEl: $(polesThumbsEl).find('.swiper-button-prev').get(0),
          },
          on: {
            // 'resize': function () {
            //   this.changeDirection(_self.getDirection());
            // },
            'lock': function(){
              if(_self.debug) console.log('lock event', this.el);
              $(this.el).addClass('swiper-pagination-locked');
            },
            'unlock': function(){
              if(_self.debug) console.log('unlock event', this.el);
              $(this.el).removeClass('swiper-pagination-locked');
              if(this.isEnd) $(this.el).addClass('swiper-reach-end');
              if(this.isBeginning) $(this.el).addClass('swiper-reach-beginning');
            },
            'reachBeginning': function(){
              if(_self.debug) console.log('reachBeginning event', this.el);
              $(this.el).addClass('swiper-reach-beginning');
            },
            'reachEnd': function(){
              if(_self.debug) console.log('reachEnd event', this.el);
              $(this.el).addClass('swiper-reach-end');
            },
            'fromEdge': function(e){
              if(_self.debug) console.log('fromEdge event', e, this.el);
              if(!this.isEnd) $(this.el).removeClass('swiper-reach-end');
              if(!this.isBeginning) $(this.el).removeClass('swiper-reach-beginning');
            },
          },
          // breakpoints: {
          //   768: {
          //     slidesPerView: 'auto'
          //   },
          //   // 1024: {
          //   //   spaceBetween: -10,
          //   // },
          //   // 1280: {
          //   //   spaceBetween: -20,
          //   // },
          // }

        });
        if(_self.debug) console.log('poleThumbsSwiper initialized ?', polesThumbsSwiper);
      });
    }

  }

}

export { SinglePole };
